export const NUMBERS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
//# sourceMappingURL=numbers.constants.js.map